import React from 'react';
import { FaChartPie, FaCoins, FaLock, FaChartLine } from 'react-icons/fa';
import { useDolphin } from '../../hooks/useDolphin';
import './admin-dashboard.css';

export default function Tokenomics() {
  const { stats } = useDolphin();
  const circulating = stats.minedTokens ? Number(stats.minedTokens) : 0;
  const total = stats.totalSupply ? Number(stats.totalSupply) : 0;
  const locked = total - circulating;
  return (
    <div className="featured-stat-card">
      <div className="featured-stat-header">
        <span className="featured-stat-icon">
          <FaChartPie />
        </span>
        <span className="featured-stat-label">Tokenomics</span>
      </div>
      <div className="featured-stat-value">Total Supply: <span style={{color:'#A78BFA'}}>{total.toLocaleString(undefined, {maximumFractionDigits: 0})}</span></div>
      <div className="price-range-bar">
        <div className="price-range-fill" style={{ width: `${total ? (circulating/total)*100 : 0}%` }}></div>
      </div>
      <div className="price-range-labels">
        <span>Circulating</span>
        <span>{circulating.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
        <span>Locked</span>
        <span>{locked.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
      </div>
      <div style={{marginTop:'1.2rem',display:'flex',gap:'1rem',alignItems:'center'}}>
        <span style={{fontSize:'0.95em',color:'#A78BFA'}}><FaCoins style={{marginRight:4}}/> Circulating: {circulating.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
        <span style={{fontSize:'0.95em',color:'#FBBF24'}}><FaLock style={{marginRight:4}}/> Locked: {locked.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
        <span style={{fontSize:'0.95em',color:'#16a34a'}}><FaChartLine style={{marginRight:4}}/> Emission: {stats.emissionRate ? stats.emissionRate : '--'}</span>
      </div>
    </div>
  );
}
